import qs from 'querystring';

import axios from 'axios';

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.timeout = 5000;

axios.interceptors.request.use((config) => {
    config.paramsSerializer = qs.stringify;

    return config;
});

export default axios;
